module.exports = __webpack_public_path__ + "static/media/Flow-payment-locker-small.57bb8fe9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/Flow-payment-locker-small.svg
// module id = 533
// module chunks = 0